import TileSettings from "web/components/AddTileWizard/TileSettings"
import { useModals } from "web/hooks/modals"

export default function useTileSettingsModal({
  isTemplate,
  overview,
  tileSettingsComponent,
  tileTitle,
  tileFetchParams,
}) {
  const { showModal } = useModals()

  return async function () {
    return await showModal({
      fullScreen: false,
      heightPixels: 800,
      message: "Updating tile. Please wait.",
      title: tileTitle,
      widthPixels: 800,
      component: ({ close }) => (
        <TileSettings
          close={close}
          isTemplate={isTemplate}
          overview={overview}
          tileSettingsComponent={tileSettingsComponent}
          tileFetchParams={tileFetchParams}
        />
      ),
    })
  }
}
